import { propagation, type Baggage, type Context } from '@opentelemetry/api';

export function setBaggageEntries(baggage: Baggage, entries: Record<string, string>): Baggage {
  for (const [key, value] of Object.entries(entries)) {
    baggage = baggage.setEntry(key, { value });
  }
  return baggage;
}

export function setBaggageEntriesOnContext(context: Context, entries: Record<string, string>): Context {
  const baggage = setBaggageEntries(propagation.getBaggage(context) || propagation.createBaggage(), entries);
  return propagation.setBaggage(context, baggage);
}
